import { render, staticRenderFns } from "./settingGLAccountClasses.vue?vue&type=template&id=27b8e3c7&scoped=true&"
import script from "./settingGLAccountClasses.vue?vue&type=script&lang=js&"
export * from "./settingGLAccountClasses.vue?vue&type=script&lang=js&"
import style0 from "./settingGLAccountClasses.vue?vue&type=style&index=0&id=27b8e3c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8e3c7",
  null
  
)

export default component.exports